"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitAddedUpdatedEntities = splitAddedUpdatedEntities;
exports.ensureEntitiesArray = exports.selectIdValue = void 0;

var selectIdValue = function selectIdValue(entity, getId) {
  var key = getId(entity);

  if (process.env.NODE_ENV !== 'production' && key === undefined) {
    // eslint-disable-next-line no-console
    console.warn('The entity passed to the `selectId` implementation returned undefined.', 'You should probably provide your own `selectId` implementation.', 'The entity that was passed:', entity, 'The `selectId` implementation:', getId.toString());
  }

  return key;
};

exports.selectIdValue = selectIdValue;

var ensureEntitiesArray = function ensureEntitiesArray(entities) {
  if (!Array.isArray(entities)) {
    return Object.values(entities);
  }

  return entities;
};

exports.ensureEntitiesArray = ensureEntitiesArray;

function splitAddedUpdatedEntities(newEntities, getId, state) {
  var entities = ensureEntitiesArray(newEntities);
  var added = [];
  var updated = [];
  entities.forEach(function (entity) {
    var id = selectIdValue(entity, getId);

    if (id in state.entities) {
      updated.push({
        id: id,
        changes: entity
      });
    } else {
      added.push(entity);
    }
  });
  return [added, updated];
}